module.exports = __webpack_public_path__ + "img/audience-report.4aab671c.svg";